<template>
  <div id="news">
    <div class="">
      <ol class="breadcrumb">
        <li>
          <a href="#/dashboard">Dashboard</a>
        </li>
        <li class="active">
          <a>Manager News</a>
        </li>
      </ol>
    </div>

    <div class="content login middle" v-loading="loading">
      <div class="cell">
        <div class="container pb100">
          <div class="row mt20">
            <p class="sub-title text-center">MANAGER NEWS</p>

            <div class="col-xs-12 mb20">
              <a href="#/newpost">
                <span class="iconfont2 icon-g7 button-icon mr20"></span>
                <span class="font16 black text-middle">CREATE NEW POST</span>
              </a>
            </div>
            <div v-if="postsList.length > 0">
              <div class="col-xs-12">
                <div class="scroll-wrapper infinite-list-wrapper" style="overflow:auto!important">
                  <table class="table table-hover">
                    <tr>
                      <th>Post Title</th>
                      <th class="text-right w30">Created Date</th>
                      <th></th>
                    </tr>
                    <tbody>
                      <tr v-for="( post,index ) in postsList" :key="index">
                        <td>{{ post.title }}</td>
                        <td
                          class="text-right w30"
                        >{{ new Date(post.created_at) | dateFormat('DD.MM.YYYY') }}</td>
                        <td class="text-right w30">
                          <el-tooltip class="item" effect="dark" content="Edit" placement="top">
                            <a class="black mr20" @click="edit_post(post)">
                              <span class="iconfont3 icon-edit font18"></span>
                            </a>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Delete" placement="top">
                            <a class="black mr20" @click="delete_post(post._id,post.title)">
                              <span class="iconfont3 icon-delete font18"></span>
                            </a>
                          </el-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/news.css";
import axios from "axios";
export default {
  name: "managernews",
  data() {
    return {
      postsList: [],
      loading: true,
    };
  },
  methods: {
    get_posts() {
      axios
        .get("/news/")
        .then(response => {
          this.postsList = response.data;
          this.loading = false;
        })
        .catch(function(error) {
          alert(error);
          this.loading = false;
        });
    },
    edit_post(post) {
      this.$router.push({name: 'newpost', params: { editingPost: post }});
    },
    delete_post(id, title) {
      axios;
      const h = this.$createElement;
      this.$msgbox({
        title: "DELETE POST",
        message: h("p", null, [
          h("span", null, "Are you sure you want to delete "),
          h("span", { style: "color: red" }, title + "?")
        ]),
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            axios
              .delete("/news/" + id)
              .then(res => {
                if (res.data.ok == 1) {
                  this.$message({
                    type: "success",
                    message: "Deleted!"
                  });
                  done();
                  this.get_posts();
                } else {
                  this.$message({
                    type: "error",
                    message: "Delete Failed!"
                  });
                }
              })
              .catch(function(error) {
                window.console.log(error);
              });
          } else {
            done();
          }
        }
      });
    }
  },
  mounted() {
    this.get_posts();
  }
};
</script>

<style>
</style>
